import { render, staticRenderFns } from "./SingleVehicle.vue?vue&type=template&id=b549ce2a"
import script from "./SingleVehicle.vue?vue&type=script&lang=js"
export * from "./SingleVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports